import { mergeMantineTheme as C, DEFAULT_THEME as y, em as z, rem as e, createTheme as S } from "@mantine/core";
function m(i, r, h) {
  return Object.keys(i[r]).reduce((F, v) => (F[v] = `var(--mantine-${h}-${v})`, F), {});
}
function g(i, r) {
  return i in r.breakpoints ? r.breakpoints[i] : z(i);
}
function x(i) {
  const r = C(y, i), h = m(r, "fontSizes", "font-size"), F = m(r, "lineHeights", "line-height"), v = m(r, "shadows", "shadow"), d = m(r, "radius", "radius"), p = m(r, "spacing", "spacing"), u = Object.keys(r.headings.sizes).reduce(
    (a, n) => (a[n] = {
      fontSize: `var(--mantine-${n}-font-size)`,
      lineHeight: `var(--mantine-${n}-line-height)`,
      fontWeight: `var(--mantine-${n}-font-weight)`
    }, a),
    {}
  ), E = Object.keys(r.colors).reduce(
    (a, n) => (a[n] = {
      0: `var(--mantine-color-${n}-0)`,
      1: `var(--mantine-color-${n}-1)`,
      2: `var(--mantine-color-${n}-2)`,
      3: `var(--mantine-color-${n}-3)`,
      4: `var(--mantine-color-${n}-4)`,
      5: `var(--mantine-color-${n}-5)`,
      6: `var(--mantine-color-${n}-6)`,
      7: `var(--mantine-color-${n}-7)`,
      8: `var(--mantine-color-${n}-8)`,
      9: `var(--mantine-color-${n}-9)`,
      filled: `var(--mantine-color-${n}-filled)`,
      filledHover: `var(--mantine-color-${n}-filled-hover)`,
      light: `var(--mantine-color-${n}-light)`,
      lightHover: `var(--mantine-color-${n}-light-hover)`,
      lightColor: `var(--mantine-color-${n}-light-color)`,
      outline: `var(--mantine-color-${n}-outline)`,
      outlineHover: `var(--mantine-color-${n}-outline-hover)`
    }, a),
    {
      primary: "var(--mantine-primary-color-filled)",
      primaryColors: {
        0: "var(--mantine-primary-color-0)",
        1: "var(--mantine-primary-color-1)",
        2: "var(--mantine-primary-color-2)",
        3: "var(--mantine-primary-color-3)",
        4: "var(--mantine-primary-color-4)",
        5: "var(--mantine-primary-color-5)",
        6: "var(--mantine-primary-color-6)",
        7: "var(--mantine-primary-color-7)",
        8: "var(--mantine-primary-color-8)",
        9: "var(--mantine-primary-color-9)",
        filled: "var(--mantine-primary-color-filled)",
        filledHover: "var(--mantine-primary-color-filled-hover)",
        light: "var(--mantine-primary-color-light)",
        lightHover: "var(--mantine-primary-color-light-hover)",
        lightColor: "var(--mantine-primary-color-light-color)",
        outline: "var(--mantine-primary-color-outline)",
        outlineHover: "var(--mantine-primary-color-outline-hover)"
      },
      white: "var(--mantine-color-white)",
      black: "var(--mantine-color-black)",
      text: "var(--mantine-color-text)",
      body: "var(--mantine-color-body)",
      error: "var(--mantine-color-error)",
      placeholder: "var(--mantine-color-placeholder)",
      anchor: "var(--mantine-color-anchor)",
      default: "var(--mantine-color-default)",
      defaultHover: "var(--mantine-color-default-hover)",
      defaultColor: "var(--mantine-color-default-color)",
      defaultBorder: "var(--mantine-color-default-border)",
      dimmed: "var(--mantine-color-dimmed)"
    }
  );
  return {
    scale: "var(--mantine-scale)",
    cursorType: "var(--mantine-cursor-type)",
    webkitFontSmoothing: "var(--mantine-webkit-font-smoothing)",
    mozFontSmoothing: "var(--mantine-moz-font-smoothing)",
    lineHeight: "var(--mantine-line-height)",
    fontFamily: "var(--mantine-font-family)",
    fontFamilyMonospace: "var(--mantine-font-family-monospace)",
    fontFamilyHeadings: "var(--mantine-font-family-headings)",
    headingFontWeight: "var(--mantine-heading-font-weight)",
    radiusDefault: "var(--mantine-radius-default)",
    breakpoints: r.breakpoints,
    fontSizes: h,
    lineHeights: F,
    shadows: v,
    radius: d,
    headings: u,
    spacing: p,
    colors: E,
    rtlSelector: '[dir="rtl"] &',
    darkSelector: '[data-mantine-color-scheme="dark"] &',
    lightSelector: '[data-mantine-color-scheme="light"] &',
    smallerThan: (a) => `(max-width: ${g(a, r)})`,
    largerThan: (a) => `(min-width: ${g(a, r)})`
  };
}
const s = {
  xl: {
    fontSize: e(24)
  },
  lg: {
    fontSize: e(20)
  },
  md: {
    fontSize: e(16)
  },
  sm: {
    fontSize: e(14)
  },
  xs: {
    fontSize: e(12)
  }
}, c = {
  h1: {
    fontSize: e(64)
  },
  h2: {
    fontSize: e(52)
  },
  h3: {
    fontSize: e(40)
  },
  h4: {
    fontSize: e(28)
  },
  h5: {
    fontSize: e(20)
  }
};
e(136), e(96);
const D = {
  100: "#EEF2FD",
  200: "#B9CCF6",
  300: "#97B3F1",
  400: "#7499ED",
  500: "#5180E8",
  600: "#225EE2",
  700: "#1B53CF",
  800: "#184AB9",
  900: "#1541A2"
}, A = {
  100: "#EAF8ED",
  200: "#ABE3B9",
  300: "#82D495",
  400: "#58C672",
  500: "#2EB84F",
  600: "#29A346",
  700: "#248F3D",
  800: "#1F7A35",
  900: "#145223"
}, $ = {
  100: "#FFFFFF",
  200: "#FAFAFA",
  300: "#F5F5F5",
  400: "#E5E5E5",
  500: "#CCCCCC",
  600: "#999999",
  700: "#666666",
  800: "#333333",
  900: "#000000"
}, b = {
  100: "#FFE6DA",
  200: "#FFCCB6",
  300: "#FFB391",
  400: "#FF996D",
  500: "#FF8048",
  600: "#FF5C14",
  700: "#FA4C00",
  800: "#E04500",
  900: "#C73D00"
}, B = {
  100: "#FFEBEB",
  200: "#FFD6D6",
  300: "#FFC2C2",
  400: "#FFADAD",
  500: "#FF9999",
  600: "#FF8080",
  700: "#FF6666",
  800: "#FF4C4C",
  900: "#FF1919"
}, w = {
  100: "#F1EDFD",
  200: "#C6B9F7",
  300: "#AA96F2",
  400: "#8D73EE",
  500: "#7150EA",
  600: "#603BE7",
  700: "#4E24E5",
  800: "#421AD6",
  900: "#3515AD"
}, k = {
  100: "#FEFEFD",
  200: "#FCFAF6",
  300: "#F7F2E9",
  400: "#F0E7D6",
  500: "#E9DCC3",
  600: "#E2D1B0",
  700: "#DCC69E",
  800: "",
  900: "#DCC69E"
}, H = {
  100: "#FEF6DA",
  200: "#FCEEB6",
  300: "#FBE591",
  400: "#F9DD6D",
  500: "#F8D448",
  600: "#F6C918",
  700: "#ECBD09",
  800: "#D3AA08",
  900: "#BB9607"
}, T = {
  500: "#2EC4A0",
  900: "#178268",
  100: "#EAF9F6"
}, j = {
  500: "#E56F43",
  900: "#9D3A16",
  100: "#FCF1EC"
}, O = {
  500: "#E33C5A",
  900: "#A11730",
  100: "#FCECEF"
}, o = {
  purple: w,
  blue: D,
  green: A,
  neutral: $,
  sand: k,
  orange: b,
  pink: B,
  yellow: H,
  positive: T,
  warning: j,
  negative: O
};
function t(i) {
  return Object.values(i);
}
const M = {
  neutral: t(o.neutral),
  sand: t(o.sand),
  blue: t(o.blue),
  purple: t(o.purple),
  green: t(o.green),
  positive: t(o.positive),
  negative: t(o.negative),
  warning: t(o.warning),
  orange: t(o.orange),
  pink: t(o.pink),
  yellow: t(o.yellow)
}, l = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  "2xl": 32,
  "3xl": 40
}, f = {
  1: "0px 2px 10px 0px rgba(0, 0, 0, 0.08)",
  3: "0px 6px 32px 0px rgba(0, 0, 0, 0.16)"
}, V = S({
  colors: M,
  shadows: {
    1: f[1],
    2: f[1],
    3: f[3]
  },
  breakpoints: { xxl: "112.5em" },
  spacing: {
    xs: e(l.xs),
    sm: e(l.sm),
    md: e(l.md),
    lg: e(l.lg),
    xl: e(l.xl),
    "2xl": e(l["2xl"]),
    "3xl": e(l["3xl"])
  },
  primaryColor: "neutral",
  fontFamily: "Telegraf",
  fontSizes: {
    xl: s.xl.fontSize,
    lg: s.lg.fontSize,
    md: s.md.fontSize,
    sm: s.sm.fontSize,
    xs: s.xs.fontSize
  },
  headings: {
    sizes: {
      h1: { fontSize: c.h1.fontSize },
      h2: { fontSize: c.h2.fontSize },
      h3: { fontSize: c.h3.fontSize },
      h4: { fontSize: c.h4.fontSize },
      h5: { fontSize: c.h5.fontSize }
    }
  }
}), W = x(V);
export {
  V as _,
  W as t
};
